import { render } from "./FixedTimePicker.vue?vue&type=template&id=1ff2b450"
import script from "./FixedTimePicker.vue?vue&type=script&lang=ts"
export * from "./FixedTimePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script